export const initialData = {
  hotelName: "",
  starRating: 1,
  email: "",
  phoneNumber: "",
  address: "",
  mapLocation: "",
  factsheet: null,
  featureImage: null,
  logo: null,
  favicon: null,
  description: "",
  socialMediaLinks: {
    facebook: "",
    instagram: "",
    tripadvisor: "",
    officialWebsite: "",
  },
  currency: "USD",
  preferredLanguage: "English",
};
